/*eslint no-script-url: 0 */
import React, { Component } from 'react';
import Frame from './Frame';
import TopMat from './TopMat';
import MiddleMat from './MiddleMat';
import BottomMat from './BottomMat';
import Glass from './Glass';
import Backing from './Backing';
import Printing from './Printing';
import FramedSize from './FramedSize';
import OriginalPictureSize from './OriginalPictureSize';

class FramingOptions extends Component {
	render() {
    return (
      <div className="cont_rgt_middle">
        <h2>Framing Options</h2>
        <table className="table">
          <tbody>
            <Frame {...this.props} />
            <TopMat {...this.props} />
            <MiddleMat {...this.props} />
            <BottomMat {...this.props} />
            <Glass {...this.props} />
            <Backing {...this.props} />
            <Printing {...this.props} />
            <FramedSize {...this.props} />
            <OriginalPictureSize {...this.props} />
          </tbody>
        </table>
      </div>
    );
	}
}

export default FramingOptions;